'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _facetGroup = require('../components/facet-group');

var _facetGroup2 = _interopRequireDefault(_facetGroup);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)("Common");

var Facets = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Facets, _React$PureComponent);

    function Facets() {
        (0, _classCallCheck3.default)(this, Facets);
        return (0, _possibleConstructorReturn3.default)(this, (Facets.__proto__ || (0, _getPrototypeOf2.default)(Facets)).apply(this, arguments));
    }

    (0, _createClass3.default)(Facets, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var groups = this.props.groups || [];
            return _react2.default.createElement(
                'div',
                { className: 'filters', id: 'accordionNo', 'aria-multiselectable': 'true' },
                _react2.default.createElement(
                    'h2',
                    { className: 'filters__title' },
                    Resx.Common.Filter,
                    ' ',
                    _react2.default.createElement('i', { className: 'icon--filter' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'filter-wrap' },
                    groups.map(function (g, i) {
                        return _react2.default.createElement(_facetGroup2.default, { group: g, key: i, onChange: _this2.props.onChange });
                    })
                )
            );
        }
    }]);
    return Facets;
}(_react2.default.PureComponent), _class.propTypes = {
    groups: _react2.default.PropTypes.array.isRequired,
    onChange: _react2.default.PropTypes.func.isRequired
}, _temp);
exports.default = Facets;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/facets/components/facets.js
// module id = 572
// module chunks = 0 2